module.exports = __webpack_public_path__ + "img/control5.526b1e1a.svg";